import axios from 'axios';
import { getSession } from 'services/auth.service';
import qs from 'qs';
import { getTerminalId } from 'modules/get-terminal-id/get-terminal-id';

const initAxios = () => {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;

  axios.defaults.paramsSerializer = (params) => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
  };

  axios.interceptors.request.use(async (config) => {
    const { idToken } = await getSession();
    try {
      config.headers.common['terminal-id'] = await getTerminalId();
    } catch (error) {
      console.error(error);
    }

    config.headers.common['x-api-key'] = idToken?.jwtToken;

    return config;
  });

  axios.interceptors.response.use(null, (error) => {
    console.groupCollapsed(
      `%c🚩 ${error.message}`,
      'background: #FAFAFA; color: red; font-size: 14px;',
    );
    console.error(error);
    console.groupEnd();
    return Promise.reject(error);
  });
};

export default initAxios;
